export default "__VITE_ASSET__08a3acb2__"